<template>
  <a-modal
    :title="$t('language.switchLanguage')"
    :visible="visible"
    @cancel="handleCancel"
    width="500px"
    :footer="null"
  >
    <div class="language-list">
      <div
        v-for="lang in languageOptions"
        :key="lang.code"
        :class="['language-item', currentLang === lang.code ? 'active' : '']"
        @click="selectLanguage(lang.code)"
      >
        <div class="language-flag">{{ lang.flag }}</div>
        <div class="language-info">
          <div class="language-name">{{ lang.label }}</div>
        </div>
        <a-icon v-if="currentLang === lang.code" type="check" class="check-icon" />
      </div>
    </div>
  </a-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'LanguageSwitchModal',
  data() {
    return {
      visible: false,
      languageOptions: [
        { code: 'en-US', label: 'English', flag: '🇺🇸' },
        { code: 'es', label: 'Vietnamese', flag: 'vn' },
      ],
    }
  },
  computed: {
    ...mapGetters('language', ['languageStorage']),
    currentLang() {
      return this.languageStorage
    },
  },
  methods: {
    ...mapActions('language', ['setLanguage']),
    open() {
      this.visible = true
    },
    handleCancel() {
      this.visible = false
    },
    selectLanguage(code) {
      this.setLanguage(code)
      this.$message.success(this.$t('language.switchSuccess'))
      this.visible = false
      // Refresh page to apply new language
      setTimeout(() => {
        window.location.reload()
      }, 300)
    },
  },
}
</script>

<style lang="less" scoped>
.language-list {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;

  .language-item {
    display: flex;
    align-items: center;
    padding: 12px 20px;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s;
    min-width: 120px;
    flex: 1;

    &:hover {
      border-color: #1890ff;
      background-color: #e6f7ff;
    }

    &.active {
      border-color: #1890ff;
      background-color: #e6f7ff;
    }

    .language-flag {
      font-size: 28px;
      margin-right: 12px;
      line-height: 1;
    }

    .language-info {
      flex: 1;

      .language-name {
        font-size: 14px;
        font-weight: 500;
        color: #262626;
      }
    }

    .check-icon {
      font-size: 20px;
      color: #1890ff;
      margin-left: 8px;
    }
  }
}
</style>
